// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { HelpCircle } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconHelpCircle(props: any) {
    return <IconBase icon={HelpCircle} {...props} />
  }

  export default IconHelpCircle
  